import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04d21b27"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aspect-edit" }
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("h2", null, [
      _withDirectives(_createElementVNode("textarea", {
        ref: "title",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.title) = $event)),
        placeholder: _ctx.$t('aspect__name'),
        class: "aspect-edit__title"
      }, null, 8, _hoisted_2), [
        [_vModelText, _ctx.data.title]
      ])
    ]),
    _createElementVNode("h3", null, [
      _withDirectives(_createElementVNode("textarea", {
        ref: "description",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.description) = $event)),
        placeholder: _ctx.$t('aspect__description'),
        class: "aspect-edit__description"
      }, null, 8, _hoisted_3), [
        [_vModelText, _ctx.data.description]
      ])
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t("aspect__type")) + ": " + _toDisplayString(_ctx.$t(`aspect__${_ctx.data.type}`)), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          title: _ctx.$t('aspect__concept'),
          class: _normalizeClass({ active: _ctx.data.type === _ctx.AspectType.Concept }),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.data.type = _ctx.AspectType.Concept))
        }, [
          _createVNode(_component_Icon, { name: "DicePositive" })
        ], 10, _hoisted_4)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          title: _ctx.$t('aspect__neutral'),
          class: _normalizeClass({ active: _ctx.data.type === _ctx.AspectType.Neutral }),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.data.type = _ctx.AspectType.Neutral))
        }, [
          _createVNode(_component_Icon, { name: "DiceNeutral" })
        ], 10, _hoisted_5)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("button", {
          title: _ctx.$t('aspect__problem'),
          class: _normalizeClass({ active: _ctx.data.type === _ctx.AspectType.Problem }),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.data.type = _ctx.AspectType.Problem))
        }, [
          _createVNode(_component_Icon, { name: "DiceNegative" })
        ], 10, _hoisted_6)
      ])
    ]),
    _createElementVNode("nav", null, [
      (_ctx.mode === 'edit')
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            title: _ctx.$t('ui-remove'),
            secondary: "",
            onClick: _ctx.remove
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("ui-remove")), 1)
            ]),
            _: 1
          }, 8, ["title", "onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Button, {
        secondary: "",
        title: _ctx.$t('ui-cancel'),
        onClick: _ctx.close
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("ui-cancel")), 1)
        ]),
        _: 1
      }, 8, ["title", "onClick"]),
      _createVNode(_component_Button, {
        title: _ctx.$t('ui-save'),
        onClick: _ctx.save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("ui-save")), 1)
        ]),
        _: 1
      }, 8, ["title", "onClick"])
    ])
  ]))
}